function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M30.279,131.982c-3.332,5.515-6.357,11.263-9.031,17.269 c-21.523,48.34-17.104,94.249-4.703,142.795c12.809,50.137,37.034,103.939,79.169,136.224c9.918,7.6,21.116,13.851,33.462,17.003 c46.502,11.87,104.234-6.254,162.637,3.475c58.402,9.729,118.317-2.241,152.316-56.867c14.388-23.118,23.374-47.622,28.756-73.83 c6.627-32.268,21.356-64.888,22.064-98.486c0.744-35.313-13.222-74.4-36.194-100.84c-26.21-30.166-68.517-33.554-104.008-48.359 c-27.979-11.671-52.244-30.52-80.536-41.492c-43.344-16.81-99.001-17.447-139.675,9.205C95.08,63.931,54.551,91.8,30.279,131.982z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M30.279,131.982c-3.332,5.515-6.357,11.263-9.031,17.269 c-21.523,48.34-17.104,94.249-4.703,142.795c12.809,50.137,37.034,103.939,79.169,136.224c9.918,7.6,21.116,13.851,33.462,17.003 c46.502,11.87,104.234-6.254,162.637,3.475c58.402,9.729,118.317-2.241,152.316-56.867c14.388-23.118,23.374-47.622,28.756-73.83 c6.627-32.268,21.356-64.888,22.064-98.486c0.744-35.313-13.222-74.4-36.194-100.84c-26.21-30.166-68.517-33.554-104.008-48.359 c-27.979-11.671-52.244-30.52-80.536-41.492c-43.344-16.81-99.001-17.447-139.675,9.205C95.08,63.931,54.551,91.8,30.279,131.982z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 3.271,
    y1: 315.85,
    x2: 491.791,
    y2: 315.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stairs"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.325,
    y: 316.227,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 77.946,
    height: 155.662
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 316.227,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 150.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 316.227,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 17.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 350.798,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 17.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 385.369,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 17.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 419.94,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 17.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.122,
    y: 454.511,
    style: {
      fill: "#BFBFBF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 66.353,
    height: 17.73
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_1"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 3.271,
    y1: 472.449,
    x2: 491.791,
    y2: 472.449
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M94.543,361.328 c0,0-1.847,5.08-5.773,5.773c-3.926,0.693-10.854-6.928-6.466-10.853C86.692,352.322,92.696,358.557,94.543,361.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M100.547,336.388c0,0-5.773,14.086-3.464,21.014c2.309,6.928,16.627,12.008,20.783,3.002c4.157-9.006-5.08-21.707-8.544-24.478 C105.859,333.155,101.702,334.079,100.547,336.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.262,342.392c0,0-9.93,9.006-11.084,18.012c-1.155,9.006,5.542,12.239,12.47,11.085c6.928-1.155,10.392-18.705,8.313-26.787 C141.883,336.619,134.262,342.392,134.262,342.392z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M136.11,392.272c0,0-11.084,0.462-11.546,5.773s4.849,6.466,10.161,1.847C140.036,395.274,140.728,392.503,136.11,392.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M124.747,399.311c0,0,8.736-3.997,12.67-4.691"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M138.581,427.026c0,0-8.142-7.535-12.234-4.119c-4.093,3.417-1.167,7.998,5.853,8.508 C139.219,431.926,141.673,430.464,138.581,427.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M125.578,423.93c0,0,8.993,3.378,12.259,5.679"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M95.633,424.807c0,0,11.224-10.388,16.865-5.678c5.641,4.71,1.609,11.025-8.068,11.729 C94.753,431.562,91.37,429.546,95.633,424.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M113.557,420.539c0,0-12.397,4.656-16.899,7.828"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M108.63,403.357 c0,0-1.155,5.542-5.311,7.621c-4.157,2.078-11.546-2.309-7.621-9.006C99.623,395.274,106.551,400.586,108.63,403.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M98.931,386.037 c0,0-2.078-4.618-10.161-1.617c-8.082,3.002-11.315,7.62-6.235,9.237C87.616,395.274,98.931,386.037,98.931,386.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M97.383,385.827c0,0-8.562,0.926-13.19,4.859"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M122.023,330.615c0,0,1.386,3.233,4.157,2.54c2.771-0.693,3.464-4.849,7.851-3.695c4.388,1.155,8.082,6.235,8.082,3.926 c0-2.309-5.542-8.313-11.777-8.313S122.254,327.613,122.023,330.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M98.931,386.037c0,0,9.943-1.909,14.084,9.133 c0.406,1.083,0.749,2.217,1.038,3.379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M140.429,375.34 c0,0,2.078-4.618,10.161-1.616c8.082,3.002,11.315,7.621,6.235,9.237C151.745,384.578,140.429,375.34,140.429,375.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M142.276,375.645c0,0,8.331-0.463,12.264,4.397"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M140.429,375.34c0,0-3.296-0.633-6.883,0.938"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M104.231,367.056c-4.874-4.977-9.688-5.728-9.688-5.728 s-7.11-1.882-9.887,0.664"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 105.221,
    y1: 341.476,
    x2: 104.788,
    y2: 339.546
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M116.466,443.565c0,0,1.035-39.768,0-51.845 c-1.035-12.077-5.866-26.224-5.866-26.224l-4.921-21.975"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 136.99,
    y1: 350.014,
    x2: 137.88,
    y2: 348.108
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M118.881,443.521c0,0,0.345-36.274,1.725-46.626 c1.38-10.352,6.901-26.57,6.901-26.57l8.473-18.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M124.747,399.311c0,0-2.415,20.796-3.796,44.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M113.015,443.521c0,0,0.69-33.168-0.69-37.654 c-1.38-4.486-3.695-2.511-3.695-2.511s-6.387,0.751-8.701,4.454"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M114.601,401.134c1.805,10.115,0.14,42.422,0.14,42.422"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M131.59,377.363c-1.998,1.368-3.919,3.576-5.245,7.111 c-4.141,11.042-3.669,59.098-3.669,59.098"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M105.433,368.373c2.157,2.533,4.249,5.957,5.857,10.58 c5.521,15.873,7.591,56.977,6.556,64.569"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M119.455,383.227c-0.336,20.033-0.574,60.294-0.574,60.294"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M119.497,380.735c0.228-13.246,0.496-26.21,0.764-33.183 c0.69-17.943,1.762-16.937,1.762-16.937s1.278-4.029,8.451-3.566"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M110.661,395.862c0,0-5.773-5.148-3.464-7.68c2.309-2.532,16.627-4.389,20.783-1.097c4.157,3.292-5.08,7.933-8.544,8.946 C115.972,397.043,111.815,396.706,110.661,395.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M115.992,391.646c-0.081,0.521-0.128,1.039-0.128,1.537"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M117.977,385.636c0,0-0.859,1.718-1.482,3.824"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M110.661,429.522c0,0-5.773-5.148-3.464-7.68c2.309-2.532,16.627-4.388,20.783-1.097c4.157,3.292-5.08,7.933-8.544,8.946 C115.972,430.704,111.815,430.366,110.661,429.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M117.977,419.297c0,0-2.113,4.227-2.113,7.547"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M114.959,415.287c0,0-3.92-3.495-2.352-5.214c1.568-1.719,11.289-2.98,14.111-0.745c2.822,2.235-3.449,5.386-5.801,6.074 C118.565,416.089,115.742,415.86,114.959,415.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M119.926,408.344c0,0-1.435,2.87-1.435,5.124"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 109.536,
    y: 437.796,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 15.628,
    height: 34.653
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M445.504,65.424v232.972 c0,2.949-2.391,5.34-5.34,5.34h-7.487"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.42,
    y: 297.546,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 430.914,
    y1: 46.581,
    x2: 339.914,
    y2: 46.581
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 435.741,
    y1: 109.645,
    x2: 369.898,
    y2: 109.645
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 435.741,
    y1: 167.57,
    x2: 369.898,
    y2: 167.57
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 435.741,
    y1: 228.576,
    x2: 369.898,
    y2: 228.576
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M465.083,72.179h-39.8c-3.224,0-5.837-2.613-5.837-5.837 v-38.76c0-3.224,2.613-5.837,5.837-5.837h39.8c3.224,0,5.837,2.613,5.837,5.837v38.76 C470.92,69.565,468.307,72.179,465.083,72.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M444.031,56.743l-13.117-10.162l-11.468,15.49v5.188 c0,2.717,2.203,4.92,4.92,4.92h41.635c2.717,0,4.919-2.202,4.92-4.919V48.998l-11.805-13.215L444.031,56.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M438.113,33.357c0,3.057-2.478,5.535-5.535,5.535 c-3.057,0-5.535-2.478-5.535-5.535c0-3.057,2.478-5.535,5.535-5.535C435.635,27.822,438.113,30.3,438.113,33.357z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M465.083,132.5h-39.8c-3.224,0-5.837-2.613-5.837-5.837 v-38.76c0-3.224,2.613-5.837,5.837-5.837h39.8c3.224,0,5.837,2.613,5.837,5.837v38.76 C470.92,129.887,468.307,132.5,465.083,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M465.083,254.336h-39.8c-3.224,0-5.837-2.613-5.837-5.837 v-38.76c0-3.224,2.613-5.837,5.837-5.837h39.8c3.224,0,5.837,2.613,5.837,5.837v38.76 C470.92,251.723,468.307,254.336,465.083,254.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M465.083,192.875h-39.8c-3.224,0-5.837-2.613-5.837-5.837 v-38.76c0-3.224,2.613-5.837,5.837-5.837h39.8c3.224,0,5.837,2.613,5.837,5.837v38.76 C470.92,190.261,468.307,192.875,465.083,192.875z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "463.444,107.283 433.697,90.109 433.697,124.457  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M427.525,150.662h15.032l0.025,5.035h-0.719c-0.236-1.802-0.911-3.02-2.024-3.656 c-0.626-0.35-1.561-0.542-2.805-0.575v13.153c0,0.919,0.16,1.529,0.483,1.83c0.321,0.301,0.989,0.451,2.005,0.451v0.634h-8.9 v-0.634c0.975,0,1.623-0.152,1.944-0.458c0.321-0.305,0.481-0.913,0.481-1.824v-13.153c-1.219,0.033-2.153,0.225-2.804,0.575 c-1.195,0.652-1.869,1.871-2.024,3.656h-0.719L427.525,150.662z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 151.55,
    x2: 465.376,
    y2: 151.55
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 157.248,
    x2: 465.376,
    y2: 157.248
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 162.947,
    x2: 465.376,
    y2: 162.947
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 168.645,
    x2: 465.376,
    y2: 168.645
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 174.343,
    x2: 465.376,
    y2: 174.343
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 180.042,
    x2: 465.376,
    y2: 180.042
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 447.289,
    y1: 185.74,
    x2: 465.376,
    y2: 185.74
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 424.991,
    y1: 174.343,
    x2: 443.077,
    y2: 174.343
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 424.991,
    y1: 180.042,
    x2: 443.077,
    y2: 180.042
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 424.991,
    y1: 185.74,
    x2: 443.077,
    y2: 185.74
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M458.059,225.936c0-7.887-8.137-14.281-18.175-14.281 c-10.038,0-18.175,6.394-18.175,14.281c0,6.602,5.703,12.154,13.448,13.79l-4.1,9.319l10.858-8.919 C450.996,239.332,458.059,233.283,458.059,225.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M436.949,222.216c0-6.76,6.975-12.24,15.579-12.24c8.604,0,15.579,5.48,15.579,12.24c0,5.658-4.888,10.418-11.526,11.82 l3.514,7.988l-9.307-7.645C443.003,233.698,436.949,228.514,436.949,222.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M369.872,46.749c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C368.001,50.929,369.872,49.057,369.872,46.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M391.923,46.749c0-2.309-1.871-4.18-4.18-4.18 s-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18S391.923,49.057,391.923,46.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M413.973,46.749c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C412.101,50.929,413.973,49.057,413.973,46.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M387.092,109.223c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C385.221,113.403,387.092,111.532,387.092,109.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M389.576,228.793c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.872-4.18,4.18c0,2.309,1.872,4.18,4.18,4.18C387.705,232.973,389.576,231.101,389.576,228.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M409.544,109.223c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C407.673,113.403,409.544,111.532,409.544,109.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M412.029,228.793c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.872-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C410.157,232.973,412.029,231.101,412.029,228.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M393.737,167.015c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.871,4.18,4.18,4.18C391.866,171.195,393.737,169.324,393.737,167.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M416.189,167.015c0-2.309-1.871-4.18-4.18-4.18 c-2.309,0-4.18,1.871-4.18,4.18c0,2.309,1.872,4.18,4.18,4.18C414.318,171.195,416.189,169.324,416.189,167.015z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339.266,
    y: 40.046,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.743,
    y: 103.591,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.743,
    y: 160.959,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.743,
    y: 222.561,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M134.904,115.564 H71.901c-5.593,0-10.127-4.534-10.127-10.127V28.25c0-5.593,4.534-10.127,10.127-10.127h63.002 c5.593,0,10.127,4.534,10.127,10.127v77.187C145.031,111.029,140.497,115.564,134.904,115.564z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M153.872,152.251H120.24 c-2.839,0-5.14-2.301-5.14-5.14v-35.248"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.718,
    y: 146.02,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 115.1,
    cy: 111.863,
    r: 4.616
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M115.197,127.697H96.516 c-2.839,0-5.14-2.301-5.14-5.14v-10.694"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 91.377,
    cy: 111.863,
    r: 4.616
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M83.66,56.272 c0-10.954,9.258-19.746,20.376-18.979c9.27,0.64,16.826,8.072,17.605,17.331c0.443,5.268-1.263,10.133-4.338,13.818 c-2.802,3.359-4.334,7.596-4.334,11.971v2.607H92.402v-2.607c0-4.37-1.523-8.607-4.325-11.96 C85.32,65.155,83.66,60.908,83.66,56.272z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.402,
    y: 83.026,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 205.3717 171.1401)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 20.568,
    height: 5.088
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M94.911,93.214h15.55c1.386,0,2.509-1.123,2.509-2.509 v-2.579H92.402v2.579C92.402,92.091,93.525,93.214,94.911,93.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M97.506,98.296h10.359c1.386,0,2.509-1.123,2.509-2.509 v-2.578H94.997v2.579C94.997,97.172,96.12,98.296,97.506,98.296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 80.96,
    y1: 56.372,
    x2: 72.245,
    y2: 56.372
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 133.943,
    y1: 56.372,
    x2: 125.116,
    y2: 56.372
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 103.094,
    y1: 34.262,
    x2: 103.094,
    y2: 25.523
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 87.297,
    y1: 40.574,
    x2: 81.281,
    y2: 34.558
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 124.908,
    y1: 78.185,
    x2: 118.804,
    y2: 72.081
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 119.065,
    y1: 40.4,
    x2: 124.908,
    y2: 34.558
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 81.281,
    y1: 78.185,
    x2: 87.098,
    y2: 72.368
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Brain"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M370.113,250.698 H155.756V116.82c0-59.193,47.985-107.179,107.179-107.179h0c59.193,0,107.179,47.986,107.179,107.179V250.698z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M262.868,54.859c-4.533-2.741-13.996-11.359-15.475-11.993 c-1.76-0.754-19.75,3.469-19.75,3.469L211.799,58.91l-12.605,3.936l-11.404,16.989l0.251,7.796l-12.574,24.143l0.702,25.148 l-4.527,17.352l5.082,15.341l9.305,11.82l1.257,17.101l13.077,10.814l15.089-1.257l9.305,17.604l21.879,5.784l16.229-7.891 V54.859z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "219.981,64.494 227.526,66.758 246.638,59.213  262.148,70.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "227.526,66.758 232.052,55.441 241.86,50.914  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "188.723,94.941 194.508,84.63 231.801,84.11  247.046,74.037  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 211.431,
    y1: 84.613,
    x2: 196.593,
    y2: 115.043
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "262.482,105.68 247.046,91.402 233.925,101.436  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "255.536,126.519 241.643,116.1 212.701,136.938  190.319,126.519  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "212.701,136.938 196.88,147.743 182.215,137.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "233.154,153.531 247.046,144.656 262.41,157.158  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "191.863,177.457 215.017,165.108 209.614,152.374  225.822,143.112  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "216.946,204.084 245.502,187.104 240.872,172.826  251.291,165.108 262.935,176.564  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "231.61,194.822 226.593,181.316 199.581,196.752  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "262.868,223.589 249.361,206.013 234.311,217.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "206.141,96.805 220.033,101.05 210,121.502  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M184.917,137.71c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701s1.209,2.701,2.701,2.701C183.707,140.411,184.917,139.202,184.917,137.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M193.02,126.519c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C191.811,129.22,193.02,128.011,193.02,126.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M194.564,177.457c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C193.355,180.158,194.564,178.949,194.564,177.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M228.523,143.112c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C227.314,145.814,228.523,144.604,228.523,143.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M235.855,153.531c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C234.646,156.233,235.855,155.023,235.855,153.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M244.345,116.1c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C243.135,118.801,244.345,117.591,244.345,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M258.237,126.519c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C257.027,129.22,258.237,128.011,258.237,126.519z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 233.925,
    cy: 101.436,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M213.087,121.888c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C211.878,124.589,213.087,123.38,213.087,121.888z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 196.494,
    cy: 116.871,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M192.249,96.033c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C191.039,98.734,192.249,97.525,192.249,96.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M250.133,74.809c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C248.924,77.51,250.133,76.3,250.133,74.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M220.033,62.846c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C218.824,65.547,220.033,64.338,220.033,62.846z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 244.562,
    cy: 50.914,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M220.419,203.698c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C219.21,206.399,220.419,205.19,220.419,203.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M202.282,196.752c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C201.073,199.453,202.282,198.244,202.282,196.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M237.013,217.59c0-1.492-1.209-2.701-2.701-2.701 c-1.492,0-2.701,1.209-2.701,2.701c0,1.492,1.209,2.701,2.701,2.701C235.803,220.291,237.013,219.082,237.013,217.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M263.002,54.859c4.533-2.741,13.996-11.359,15.475-11.993 c1.76-0.754,19.75,3.469,19.75,3.469L314.07,58.91l12.604,3.936l11.404,16.989l-0.251,7.796l12.574,24.143l-0.702,25.148 l4.527,17.352l-5.082,15.341l-9.305,11.82l-1.258,17.101l-13.077,10.814l-15.089-1.257l-9.305,17.604l-21.879,5.784 l-16.229-7.891V54.859z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "305.888,64.494 298.344,66.758 279.231,59.213  263.721,70.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "298.344,66.758 293.817,55.441 284.009,50.914  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "337.146,94.941 331.362,84.63 294.069,84.11  278.824,74.037  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 314.439,
    y1: 84.613,
    x2: 329.276,
    y2: 115.043
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "263.388,105.68 278.824,91.402 291.944,101.436  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "270.334,126.519 284.226,116.1 313.168,136.938  335.55,126.519  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "313.168,136.938 328.99,147.743 343.654,137.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "292.716,153.531 278.824,144.656 263.459,157.158  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "334.007,177.457 310.853,165.108 316.255,152.374  300.048,143.112  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "308.923,204.084 280.367,187.104 284.998,172.826  274.579,165.108 262.935,176.564  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "294.259,194.822 299.276,181.316 326.289,196.752  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "263.002,223.589 276.508,206.013 291.558,217.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "319.729,96.805 305.836,101.05 315.87,121.502  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M340.953,137.71c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701s-1.209,2.701-2.701,2.701C342.162,140.411,340.953,139.202,340.953,137.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M332.849,126.519c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C334.059,129.22,332.849,128.011,332.849,126.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M331.305,177.457c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C332.515,180.158,331.305,178.949,331.305,177.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M297.347,143.112c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C298.556,145.814,297.347,144.604,297.347,143.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M290.015,153.531c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C291.224,156.233,290.015,155.023,290.015,153.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M281.525,116.1c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C282.734,118.801,281.525,117.591,281.525,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M267.633,126.519c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C268.842,129.22,267.633,128.011,267.633,126.519z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 291.944,
    cy: 101.436,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M312.783,121.888c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C313.992,124.589,312.783,123.38,312.783,121.888z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 329.376,
    cy: 116.871,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M333.621,96.033c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C334.83,98.734,333.621,97.525,333.621,96.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M275.736,74.809c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C276.946,77.51,275.736,76.3,275.736,74.809z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 308.538,
    cy: 62.846,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M278.607,50.914c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701s-1.209,2.701-2.701,2.701C279.816,53.616,278.607,52.406,278.607,50.914z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 308.152,
    cy: 203.698,
    r: 2.701
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M323.588,196.752c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C324.797,199.453,323.588,198.244,323.588,196.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M288.857,217.59c0-1.492,1.209-2.701,2.701-2.701 c1.492,0,2.701,1.209,2.701,2.701c0,1.492-1.209,2.701-2.701,2.701C290.066,220.291,288.857,219.082,288.857,217.59z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M380.241,315.785 H145.629v-58.136c0-4.308,3.492-7.8,7.8-7.8h219.012c4.308,0,7.8,3.492,7.8,7.8V315.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M209.916,303.777h-38.024 c-2.839,0-5.14-2.301-5.14-5.14V263.39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.313,
    y: 297.546,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 166.752,
    cy: 263.39,
    r: 4.616
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 186.578,
    cy: 263.39,
    r: 4.616
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 206.404,
    cy: 263.39,
    r: 4.616
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M167.888,281.468h15.524 c1.749,0,3.166-1.418,3.166-3.166v-10.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M186.945,274.505h16.506 c1.749,0,3.166-1.418,3.166-3.166v-3.333"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M347.287,303.777h-33.632 c-2.839,0-5.14-2.301-5.14-5.14V263.39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.133,
    y: 297.546,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 8.308,
    height: 12.462
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 308.515,
    cy: 263.39,
    r: 4.616
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M308.612,279.224h-18.681 c-2.839,0-5.14-2.301-5.14-5.14V263.39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M289.408,263.39c0-2.549-2.067-4.616-4.616-4.616 c-2.549,0-4.616,2.066-4.616,4.616s2.067,4.616,4.616,4.616C287.341,268.006,289.408,265.939,289.408,263.39z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M356.689,222.565 c0,3.854-3.125,6.979-6.979,6.979s-6.979-3.125-6.979-6.979s3.125-6.979,6.979-6.979S356.689,218.711,356.689,222.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M357.324,195.284 c0,1.051-0.852,1.903-1.903,1.903c-1.051,0-1.903-0.852-1.903-1.903s0.852-1.903,1.903-1.903 C356.472,193.38,357.324,194.232,357.324,195.284z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 184.116,
    cy: 224.469,
    r: 3.172
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 169.207,
    cy: 193.697,
    r: 3.49
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M180.944,83.619 c0,1.051-0.852,1.903-1.903,1.903c-1.051,0-1.903-0.852-1.903-1.903s0.852-1.903,1.903-1.903 C180.092,81.715,180.944,82.568,180.944,83.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M254.541,27.786 c0,3.154-2.557,5.71-5.71,5.71c-3.154,0-5.71-2.556-5.71-5.71s2.557-5.71,5.71-5.71C251.985,22.076,254.541,24.633,254.541,27.786 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M286.899,31.91 c0,0.876-0.71,1.586-1.586,1.586c-0.876,0-1.586-0.71-1.586-1.586s0.71-1.586,1.586-1.586 C286.189,30.324,286.899,31.034,286.899,31.91z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.499,
    y: 259.397,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.952,
    y: 259.397,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.405,
    y: 259.397,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.858,
    y: 259.397,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.311,
    y: 259.397,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.764,
    y: 259.397,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 4.302,
    height: 8.174
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.817 -0.5766 0.5766 0.817 24.7604 196.693)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 322.306,
    cy: 59.332,
    rx: 18.258,
    ry: 24.725
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M314.521,86.009 c4.48,6.349,4.312,14.177-0.376,17.486c-4.688,3.308-12.121,0.844-16.601-5.505c-4.48-6.349-4.312-14.177,0.376-17.486 C302.609,77.196,310.041,79.661,314.521,86.009z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Devices"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 351.196,
    y: 285.381,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 80.245,
    height: 63.567
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.385,
    y: 348.902,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 15.866,
    height: 15.923
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.44,
    y: 362.252,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 41.756,
    height: 2.572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.735,
    y: 290.562,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 67.166,
    height: 53.206
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 391.318,
    cy: 317.165,
    r: 22.796
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 391.318,
    cy: 317.165,
    rx: 14.251,
    ry: 22.796
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 372.694,
    y1: 304.401,
    x2: 410.214,
    y2: 304.401
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 372.694,
    y1: 329.994,
    x2: 410.214,
    y2: 329.994
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 368.794,
    y1: 317.165,
    x2: 414.114,
    y2: 317.165
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 391.318,
    y1: 294.369,
    x2: 391.318,
    y2: 339.961
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.307,
    y: 285.381,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 80.245,
    height: 63.567
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.497,
    y: 348.902,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 15.866,
    height: 15.923
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.552,
    y: 362.252,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 41.756,
    height: 2.572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.847,
    y: 290.562,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 67.166,
    height: 53.206
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 229.391,
    y1: 300.19,
    x2: 238.419,
    y2: 300.19
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 229.391,
    y1: 322.431,
    x2: 238.419,
    y2: 322.431
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 235.777,
    y1: 303.713,
    x2: 242.163,
    y2: 303.713
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 244.365,
    y1: 303.713,
    x2: 250.751,
    y2: 303.713
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 307.237,
    x2: 245.686,
    y2: 307.237
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 246.787,
    y1: 307.237,
    x2: 253.174,
    y2: 307.237
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 310.32,
    x2: 245.686,
    y2: 310.32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 246.787,
    y1: 310.32,
    x2: 253.174,
    y2: 310.32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 313.403,
    x2: 245.686,
    y2: 313.403
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 246.787,
    y1: 313.403,
    x2: 253.174,
    y2: 313.403
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 316.926,
    x2: 245.686,
    y2: 316.926
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 325.074,
    x2: 245.686,
    y2: 325.074
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 328.157,
    x2: 245.686,
    y2: 328.157
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 331.24,
    x2: 245.686,
    y2: 331.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 239.3,
    y1: 334.323,
    x2: 245.686,
    y2: 334.323
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 248.549,
    y1: 325.074,
    x2: 254.935,
    y2: 325.074
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 248.549,
    y1: 328.157,
    x2: 254.935,
    y2: 328.157
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 248.549,
    y1: 331.24,
    x2: 254.935,
    y2: 331.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 248.549,
    y1: 334.323,
    x2: 254.935,
    y2: 334.323
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 296.226,
    x2: 285.325,
    y2: 296.226
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 299.309,
    x2: 285.325,
    y2: 299.309
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 302.392,
    x2: 285.325,
    y2: 302.392
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 305.475,
    x2: 285.325,
    y2: 305.475
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 308.558,
    x2: 285.325,
    y2: 308.558
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 311.641,
    x2: 285.325,
    y2: 311.641
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 314.724,
    x2: 285.325,
    y2: 314.724
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 317.807,
    x2: 285.325,
    y2: 317.807
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 320.89,
    x2: 285.325,
    y2: 320.89
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 323.973,
    x2: 285.325,
    y2: 323.973
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 327.056,
    x2: 285.325,
    y2: 327.056
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 278.939,
    y1: 330.139,
    x2: 285.325,
    y2: 330.139
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 257.798,
    y1: 325.074,
    x2: 264.184,
    y2: 325.074
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 257.798,
    y1: 328.157,
    x2: 264.184,
    y2: 328.157
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 257.798,
    y1: 331.24,
    x2: 264.184,
    y2: 331.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 257.798,
    y1: 334.323,
    x2: 264.184,
    y2: 334.323
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 246.787,
    y1: 316.926,
    x2: 253.174,
    y2: 316.926
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 254.935,
    y1: 316.926,
    x2: 261.322,
    y2: 316.926
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 262.423,
    y1: 316.926,
    x2: 268.809,
    y2: 316.926
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 252.953,
    y1: 303.713,
    x2: 259.34,
    y2: 303.713
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 261.542,
    y1: 303.713,
    x2: 267.928,
    y2: 303.713
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.283,
    y: 364.882,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 293.186,
    height: 27.338
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -154.6262 385.6758)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 388.239,
    cy: 379.488,
    rx: 10.172,
    ry: 10.172
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9846 -0.1748 0.1748 0.9846 -59.9625 78.229)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 414.082,
    cy: 379.488,
    rx: 10.172,
    ry: 10.172
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.987 -0.1607 0.1607 0.987 -57.7558 44.8062)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 248.144,
    cy: 379.488,
    rx: 10.172,
    ry: 10.172
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9743 -0.2253 0.2253 0.9743 -78.4452 71.4757)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 273.987,
    cy: 379.488,
    rx: 10.172,
    ry: 10.172
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M177.283,402.88 l-29.319,69.565h47.979v-54.951c0-4.709,3.818-8.527,8.527-8.527h242.751c4.709,0,8.527,3.818,8.527,8.527v54.951h44.04 l-29.319-69.565H177.283z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.452,
    y: 392.315,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 330.849,
    height: 10.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343.331,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.32,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.309,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343.331,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.32,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.309,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.599,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.588,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.577,
    y: 369.909,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.599,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.471,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.588,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.577,
    y: 378.116,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 5.472,
    height: 5.471
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M328.089,388.278L328.089,388.278 c-0.863,0-1.563-0.7-1.563-1.563v-17.196c0-0.863,0.7-1.563,1.563-1.563l0,0c0.863,0,1.563,0.7,1.563,1.563v17.196 C329.652,387.578,328.952,388.278,328.089,388.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M463.705,388.278L463.705,388.278 c-0.863,0-1.563-0.7-1.563-1.563v-17.196c0-0.863,0.7-1.563,1.563-1.563l0,0c0.863,0,1.563,0.7,1.563,1.563v17.196 C465.268,387.578,464.568,388.278,463.705,388.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M227.256,388.278L227.256,388.278 c-0.863,0-1.563-0.7-1.563-1.563v-17.196c0-0.863,0.7-1.563,1.563-1.563l0,0c0.863,0,1.563,0.7,1.563,1.563v17.196 C228.819,387.578,228.119,388.278,227.256,388.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M319.1,388.278L319.1,388.278c-0.863,0-1.563-0.7-1.563-1.563 v-17.196c0-0.863,0.7-1.563,1.563-1.563l0,0c0.863,0,1.563,0.7,1.563,1.563v17.196C320.663,387.578,319.963,388.278,319.1,388.278 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 412.355,343.159 412.355,335.364 423.47,335.364 423.47,343.737  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M406.869,325.403c0,0-1.732-0.433-1.732,2.31c0,2.743,2.31,4.62,3.176,4.475c0.866-0.144-0.433-5.341-0.577-6.352 C407.591,324.826,406.869,325.403,406.869,325.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M428.53,325.403c0,0,1.732-0.433,1.732,2.31c0,2.743-2.31,4.62-3.176,4.475c-0.866-0.144,0.433-5.341,0.577-6.352 C427.808,324.826,428.53,325.403,428.53,325.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M414.52,311.689c0,0-4.908,0.722-6.929,5.053c-2.021,4.331-0.577,10.394,0.144,13.859c0.722,3.465,3.609,6.785,5.774,7.507 c2.165,0.722,8.806,0,8.806,0s2.165-2.021,4.186-5.63c2.021-3.609,2.31-10.394,1.443-14.292 c-0.866-3.898-3.898-7.795-6.207-8.084c-2.31-0.289-4.475,1.877-4.475,1.877S416.397,311.4,414.52,311.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M425.059,341.716c0,0-8.373-1.299-12.126-0.722c-3.753,0.577-6.063,5.197-6.063,5.197s4.475-1.444,9.383-1.444 c4.908,0,11.693,0.866,11.693,0.866S426.791,343.159,425.059,341.716z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M393.444,355.43c0,0-15.901,25.102-16.309,27.55c-0.408,2.448,2.04,6.12,6.324,5.712c4.284-0.408,20.197-0.612,20.197-0.612 l0.204-3.876l-12.853-1.632l7.752-6.12L393.444,355.43z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 391.008,
    y1: 382.572,
    x2: 384.683,
    y2: 385.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M442.382,354.419c0,0,16.109,26.112,16.517,28.56c0.408,2.448-2.04,6.12-6.324,5.712c-4.284-0.408-20.197-0.612-20.197-0.612 l-0.204-3.876l12.853-1.632l-7.752-6.12L442.382,354.419z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 445.026,
    y1: 382.572,
    x2: 451.35,
    y2: 385.632
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M411.489,343.881c0,0-4.908,2.598-9.816,5.197c-4.908,2.598-7.94,5.053-8.229,6.352c-0.289,1.299,5.486,42.442,5.486,42.442 s3.715,3.653,13.57,4.62c14.725,1.444,21.077-3.176,21.077-3.176s8.806-43.308,8.806-44.896c0-1.588-11.116-6.929-15.014-8.806 C423.47,343.737,419.14,342.149,411.489,343.881z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 390.556,409.854 407.735,464.76 412.499,464.183 405.426,408.555  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M407.735,464.76l1.129,6.272c0.095,0.53,0.59,0.893,1.124,0.824l3.487-0.447c0.622-0.08,1.022-0.7,0.839-1.299l-1.814-5.927 L407.735,464.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 443.519,409.854 426.34,464.76 421.576,464.183 428.65,408.555  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M426.34,464.76l-1.129,6.272c-0.095,0.53-0.59,0.893-1.124,0.824l-3.487-0.447c-0.622-0.08-1.022-0.7-0.839-1.299l1.814-5.927 L426.34,464.76z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M413.654,403.358c0,0-15.735-4.908-18.623-3.465c-2.887,1.444-5.774,5.197-4.764,9.383c1.01,4.186,9.672,9.239,11.549,9.383 c1.877,0.144,11.982,0,11.982,0L413.654,403.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M421.388,403.358c0,0,15.735-4.908,18.623-3.465c2.887,1.444,5.774,5.197,4.764,9.383c-1.01,4.186-9.672,9.239-11.549,9.383 c-1.877,0.144-11.982,0-11.982,0L421.388,403.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M398.929,397.872c0,0-1.299,14.436-0.866,16.313c0.433,1.877,4.908,4.908,14.003,5.197s20.499,0.722,23.242-2.598 c2.743-3.32-1.732-17.468-1.732-17.468S409.323,401.337,398.929,397.872z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9249 -0.3801 0.3801 0.9249 -126.2497 185.1789)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 405.777,
    cy: 412.273,
    rx: 11.127,
    ry: 11.127
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7963 -0.6048 0.6048 0.7963 -161.9745 343.488)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 429.087,
    cy: 412.273,
    rx: 11.127,
    ry: 11.127
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M401.32,400.435 l-2.361,9.469c-0.413,1.657-0.207,3.408,0.579,4.924l4.444,8.572h27.109l4.291-8.01c1.128-2.106,1.274-4.601,0.4-6.824 l-3.197-8.131H401.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.407,
    y: 417.394,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.67,
    height: 21.637
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.966,
    y: 435.631,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.551,
    height: 27.363
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 422.337,462.273 418.377,461.207 418.377,461.013 418.017,461.11 417.657,461.013 417.657,461.207 413.696,462.273  386.694,467.314 386.694,469.294 417.657,469.294 418.377,469.294 449.34,469.294 449.34,467.314  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 389.034,
    cy: 470.554,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 418.017,
    cy: 470.554,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M449.07,470.554c0,1.044-0.846,1.89-1.89,1.89c-1.044,0-1.89-0.846-1.89-1.89c0-1.044,0.846-1.89,1.89-1.89 C448.224,468.664,449.07,469.51,449.07,470.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M396.494,420.962L396.494,420.962c-3.098,0-5.61-2.512-5.61-5.61v-18.699h5.61V420.962z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.679,
    y: 391.578,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.815,
    height: 4.541
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M440.185,420.962L440.185,420.962c3.098,0,5.61-2.512,5.61-5.61v-18.699h-5.61V420.962z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.185,
    y: 391.578,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 889.1856 787.6964)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.815,
    height: 4.541
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M435.618,424.237h-34.752c-4.063,0-7.357-3.294-7.357-7.356l4.122-51.958c0-3.386,2.745-6.13,6.13-6.13h28.96 c3.386,0,6.13,2.745,6.13,6.13l4.122,51.958C442.974,420.943,439.681,424.237,435.618,424.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M435.618,426.971h-34.752c-4.063,0-7.357-3.294-7.357-7.357l4.122-51.958c0-3.386,2.745-6.13,6.13-6.13h28.96 c3.386,0,6.13,2.745,6.13,6.13l4.122,51.958C442.974,423.677,439.681,426.971,435.618,426.971z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 253.279,407.001 262.221,464.286 267.01,464.579 268.139,408.409  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M262.221,464.286l-0.023,6.372c-0.002,0.539,0.419,0.985,0.957,1.014l3.51,0.19c0.626,0.034,1.132-0.504,1.06-1.127 l-0.714-6.157L262.221,464.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 288.213,407.139 278.286,464.224 273.491,464.415 273.327,408.231  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M278.286,464.224l-0.113,6.371c-0.009,0.539-0.44,0.975-0.978,0.993l-3.513,0.116c-0.627,0.021-1.121-0.528-1.035-1.149 l0.844-6.14L278.286,464.224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M250.459,351.65c0,0-14.967,29.014-15.375,31.462c-0.408,2.448,2.04,6.12,6.324,5.712c4.284-0.408,15.436-0.612,15.436-0.612 l0.204-3.876l-12.853-1.632l7.752-6.12L250.459,351.65z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 244.196,
    y1: 382.704,
    x2: 242.632,
    y2: 385.764
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M290.698,351.021c0,0,15.078,29.643,15.486,32.091c0.408,2.448-2.04,6.12-6.324,5.712c-4.284-0.408-14.294-0.612-14.294-0.612 l-0.204-3.876l6.95-1.632l-4.389-6.084L290.698,351.021z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 292.312,
    y1: 382.704,
    x2: 298.636,
    y2: 385.764
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M264.677,344.013c0,0-4.908,2.598-9.816,5.197c-4.908,2.598-4.113,1.141-4.402,2.44c-0.289,1.299,1.659,46.354,1.659,46.354 s3.715,3.653,13.57,4.62c14.725,1.444,21.077-3.176,21.077-3.176s3.767-45.583,3.767-47.171c0-1.588-6.077-4.654-9.974-6.531 C276.659,343.869,272.328,342.281,264.677,344.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M252.118,398.004c0,0-1.299,14.436-0.866,16.313c0.433,1.877,4.908,4.908,14.003,5.197c9.095,0.289,20.499,0.722,23.242-2.598 c2.743-3.32-1.732-17.468-1.732-17.468S262.512,401.469,252.118,398.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M271.456,315.746c0,0-4.701-2.778-9.615,2.564c-4.914,5.342,0.214,16.025,0.855,18.589c0.641,2.564-8.547,17.093-8.547,23.717 s7.906,13.034,20.512,11.751c12.606-1.282,14.102-7.906,12.393-15.811c-1.709-7.906-3.632-16.238-3.632-19.657 s2.991-11.111,0.214-18.589C280.858,310.832,274.02,312.969,271.456,315.746z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#808080",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M264.619,338.181 l5.769,5.555c0,0-5.983,14.315-6.624,18.161c-0.641,3.846,2.778,7.478,7.478,7.051c4.701-0.427,7.692-4.487,7.478-7.906 c-0.214-3.419-3.632-17.52-3.632-17.52s4.487-2.137,7.265-6.624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M270.388,343.737 c0,0,0.214-1.496,4.701-0.214"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2309 -0.973 0.973 0.2309 -202.3941 568.5136)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 258.394,
    cy: 412.273,
    rx: 11.127,
    ry: 11.127
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -209.0121 319.9468)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 281.704,
    cy: 412.273,
    rx: 11.127,
    ry: 11.127
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.937,400.435l-2.361,9.469c-0.413,1.657-0.207,3.408,0.579,4.924l4.445,8.572h27.109l4.291-8.01 c1.128-2.106,1.274-4.601,0.4-6.824l-3.197-8.131H253.937z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 268.024,
    y: 417.394,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.67,
    height: 21.637
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.584,
    y: 435.631,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.551,
    height: 27.363
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 274.954,462.273 270.994,461.207 270.994,461.013 270.634,461.11 270.274,461.013 270.274,461.207 266.314,462.273  239.311,467.314 239.311,469.294 270.274,469.294 270.994,469.294 301.957,469.294 301.957,467.314  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M243.541,470.554c0,1.044-0.846,1.89-1.89,1.89c-1.044,0-1.89-0.846-1.89-1.89c0-1.044,0.846-1.89,1.89-1.89 C242.695,468.664,243.541,469.51,243.541,470.554z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 270.634,
    cy: 470.554,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 299.797,
    cy: 470.554,
    r: 1.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M249.111,420.962L249.111,420.962c-3.098,0-5.61-2.512-5.61-5.61v-18.699h5.61V420.962z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.296,
    y: 391.578,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.815,
    height: 4.541
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M292.802,420.962L292.802,420.962c3.098,0,5.61-2.512,5.61-5.61v-18.699h-5.61V420.962z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.802,
    y: 391.578,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 594.42 787.6964)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.815,
    height: 4.541
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M288.235,424.237h-34.752c-4.063,0-7.357-3.294-7.357-7.356l4.122-51.958c0-3.386,2.745-6.13,6.13-6.13h28.96 c3.386,0,6.131,2.745,6.131,6.13l4.122,51.958C295.592,420.943,292.298,424.237,288.235,424.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M288.235,426.971h-34.752c-4.063,0-7.357-3.294-7.357-7.357l4.122-51.958c0-3.386,2.745-6.13,6.13-6.13h28.96 c3.386,0,6.131,2.745,6.131,6.13l4.122,51.958C295.592,423.677,292.298,426.971,288.235,426.971z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M61.084,123.19 c0,0,1.77,4.085,1.634,5.038c-0.136,0.953-0.272,2.587,0,3.404c0.272,0.817,0.953,2.315,0.409,4.63 c-0.545,2.315-0.953,6.536-2.179,7.489c-1.225,0.953-3.54-0.136-3.54-0.136l-0.136,4.766l-11.03,0.408l-1.089-7.625 c0,0-2.179-7.898,0.817-14.978C48.965,119.105,60.267,121.965,61.084,123.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M57.544,137.488 c0,0,0.409,0.681,1.226,0.953c0.817,0.272,0.953-2.179,0.953-2.179"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 59.042,
    y1: 131.633,
    x2: 65.306,
    y2: 129.59
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M62.854,127.82 c1.654,0,2.996,1.341,2.996,2.996c0,1.404-0.966,2.582-2.269,2.907"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M61.084,123.19 c0,0,0.409,2.179-0.272,3.54s-2.179,2.996-2.179,2.996s0.681,1.498,0.409,1.906c-0.272,0.409-0.681-0.545-1.226-0.545 s-1.634,0-1.362,2.179c0.272,2.179,1.089,4.221,1.089,4.221s-0.409,2.859-3.404,4.63s-7.217,1.498-8.579,0.817 c-1.362-0.681-8.034-9.804-8.034-16.204c0-6.4,9.94-11.983,15.387-11.983c5.447,0,11.983,2.723,11.983,5.447 C64.897,122.918,61.084,123.19,61.084,123.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M43.655,147.156 l-2.179,4.085c0,0,5.447-0.681,10.621-0.817c5.174-0.136,8.715,0.409,8.715,0.409l-1.362-3.677 C59.45,147.156,48.421,145.114,43.655,147.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M31.264,156.824 c0,0-2.996,12.936-2.996,21.242c0,8.306-0.817,13.344,0.953,14.025c1.77,0.681,8.306-2.451,8.306-2.451l-3.404-30.229 L31.264,156.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M36.71,191.819 c0,0-4.493,3.404-6.536,16.885c-2.043,13.481,2.043,35.268,4.63,40.85s3.132,7.625,2.996,9.532s-3.404,5.719-1.089,15.796 c2.315,10.076,5.038,27.642,5.038,27.642v1.634c0,0-0.817,0.545-0.545,1.089c0.272,0.545,0.681,2.859,0.681,2.859l5.991,0.136 c0,0,1.498-2.315,1.498-4.221c0-1.906-0.272-4.902-0.272-4.902l-0.136-5.311l1.498-56.782l0.545-11.438l10.757,34.859 l13.344,44.663c0,0,3.677,0.272,5.038,0.136c1.362-0.136,3.54-0.545,3.54-0.545s0.409-1.634,0.136-2.723 c-0.272-1.089-0.953-2.587-1.77-4.085s-1.906-12.255-2.179-13.889c-0.272-1.634-1.089-17.838-2.315-21.651 c-1.225-3.813-3.268-7.217-3.268-7.217s-1.634-39.625-4.766-50.11c-3.132-10.485-5.038-12.391-5.038-12.391 S50.327,194.406,36.71,191.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M41.476,151.241 c0,0-10.213,4.902-10.213,5.583c0,0.681,5.447,34.995,5.447,34.995s5.991,3.676,15.251,2.859 c9.259-0.817,12.527-2.042,12.527-2.042s6.808-36.221,6.128-37.31c-0.681-1.089-9.804-4.493-9.804-4.493 S47.876,148.79,41.476,151.241z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 74.565,149.199 89.816,151.514 82.871,175.615 67.757,171.666  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M75.927,181.607 c0,0,4.085-7.626,4.494-7.898c0.409-0.272-0.681-3.949-0.545-4.902c0.136-0.953,0.408-1.77,0.953-3.132 c0.545-1.362-0.136-2.587,0.817-2.315c0.953,0.272,1.226,0.817,1.089,2.179c-0.136,1.362-0.136,2.315-0.136,2.315l3.54-2.996 l1.089-3.404c0,0,0.953,1.906,0.953,3.268s-0.272,2.042-0.409,2.451c-0.136,0.408,0,3.268-1.498,5.583 c-1.498,2.315-2.179,2.723-2.451,3.404c-0.272,0.681-0.817,5.991-2.451,10.485c-1.634,4.493-3.268,8.306-5.447,8.987 c-2.179,0.681-3.813-4.902-2.859-8.17C74.02,184.194,75.927,181.607,75.927,181.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M61.084,173.709 c0,0,6.672,17.974,8.579,20.561c1.906,2.587,6.808,1.77,7.898-0.545c1.089-2.315,0.272-6.4-0.136-8.442 s-2.996-16.613-3.676-21.242c-0.681-4.63-3.132-8.715-3.132-8.715s-3.132-2.042-5.174-0.272"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 51.008,
    y1: 225.589,
    x2: 43.559,
    y2: 222.42
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 41.885,308.107 41.646,315.707 48.731,315.707 47.876,308.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 41.646,315.707 48.731,315.707 48.518,313.842 41.705,313.842  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M75.11,305.111 c0,0-1.766,7.364-1.145,7.737c0.621,0.373,5.469,1.243,7.085,1.74c1.616,0.497,5.345,1.367,6.961,1.367 c1.616,0,4.226,0,4.35-0.87c0.124-0.87,0.249-1.492-0.373-1.865c-0.622-0.373-3.48-2.486-5.469-4.475 c-1.989-1.989-2.831-4.043-2.831-4.043L75.11,305.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M81.174,312.35 c-3.409-1.442-5.737-1.74-7.184-1.703c-0.173,1.159-0.234,2.075-0.025,2.2c0.621,0.373,5.469,1.243,7.085,1.74 c1.616,0.497,5.345,1.367,6.961,1.367c1.616,0,4.226,0,4.35-0.87c0.052-0.361,0.1-0.677,0.098-0.952 C90.716,314.41,86.496,314.602,81.174,312.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/HomeImage.7059fcabe2d491bcba4712fc4492c594.svg";
export { ForwardRef as ReactComponent };